import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, CheckCircle2 } from 'lucide-react';
import api from '../services/api';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
    } catch (err) {
      // La respuesta del backend es siempre 200 — un error aquí es de red, no de negocio.
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <span style={{ color: 'white', fontWeight: 600, fontSize: '28px', letterSpacing: '-0.5px', lineHeight: 1 }}>AdamSched</span>
        </div>

        {sent ? (
          <div className="space-y-4 text-center">
            <CheckCircle2 className="w-10 h-10 text-emerald-500 mx-auto" />
            <p className="text-sm text-zinc-300">{t('auth.resetLinkSent')}</p>
            <Button
              type="button"
              variant="outline"
              className="w-full h-10"
              onClick={() => navigate('/login')}
              data-testid="forgot-password-back-to-login"
            >
              {t('auth.backToLogin')}
            </Button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <h1 className="text-lg font-semibold text-center text-white">{t('auth.forgotPasswordTitle')}</h1>
            <p className="text-sm text-zinc-400 text-center">{t('auth.forgotPasswordSubtitle')}</p>

            <div className="space-y-2">
              <Label htmlFor="email">{t('auth.email')}</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                className="input-tactical"
                required
                data-testid="forgot-password-email"
              />
            </div>

            <Button
              type="submit"
              className="w-full btn-primary h-10"
              disabled={loading}
              data-testid="forgot-password-submit"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : t('auth.sendResetLink')}
            </Button>

            <button
              type="button"
              onClick={() => navigate('/login')}
              className="text-sm text-gray-500 hover:text-gray-700 underline mt-2 block mx-auto"
            >
              {t('auth.backToLogin')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
